import { useCarousel } from "nuka-carousel";
import { defineMessages } from "react-intl";

import { useFormatMessage } from "../Intl/Context";
import { useCarouselContext } from "./Carousel";
import Button from "../Buttons/Button";

const CarouselControlArrows = () => {
  const { currentPage, totalPages, wrapMode, goBack, goForward } = useCarousel();
  const { carouselFrameDOMId } = useCarouselContext();

  const t = useFormatMessage();
  const previousSlideLabel = t(intlMessages.previousSlide);
  const nextSlideLabel = t(intlMessages.nextSlide);

  const allowWrap = wrapMode === "wrap";
  const enablePrevNavButton = allowWrap || currentPage > 0;
  const enableNextNavButton = allowWrap || currentPage < totalPages - 1;

  return (
    <div className="slider-control-arrows">
      {enablePrevNavButton && (
        <Button
          type="button"
          className="btn-unstyled slider-control"
          onClick={goBack}
          iconClassName="fa fa-chevron-left slider-control-previous"
          aria-controls={carouselFrameDOMId}
          screenReaderLabel={previousSlideLabel}
        />
      )}

      {enableNextNavButton && (
        <Button
          type="button"
          className="btn-unstyled slider-control"
          onClick={goForward}
          iconClassName="fa fa-chevron-right slider-control-next"
          aria-controls={carouselFrameDOMId}
          screenReaderLabel={nextSlideLabel}
        />
      )}
    </div>
  );
};

export default CarouselControlArrows;

const intlMessages = defineMessages({
  previousSlide: {
    id: "slideshowCarousel.previousSlide",
    defaultMessage: "Aller à la diapositive précédente"
  },
  nextSlide: {
    id: "slideshowCarousel.nextSlide",
    defaultMessage: "Aller à la diapositive suivante"
  }
});
